import type { IndustryItem } from "@/types/home";
import {
  Landmark,
  HeartPulse,
  ShoppingBag,
  Cloud,
  GraduationCap,
  Truck,
  Factory,
  UtensilsCrossed
} from "lucide-react";

/** Industries VibeWell serves, with distinct illustration tints. */
export const industries: IndustryItem[] = [
  {
    id: "manufacturing",
    name: "Manufacturing",
    description: "Digitise production, inventory, quality and maintenance with intelligent manufacturing software.",
    icon: Factory,
    gradient: "from-primary/20 to-accent/10",
    tags:["ERP", "MES", "Quality", "Maintenance"],
  },
  {
    id: "fintech",
    name: "Fintech",
    description: "Secure, compliant products that move money with confidence.",
    icon: Landmark,
    gradient: "from-primary/20 to-accent/10",
    tags:[],
  },
  {
    id: "healthcare",
    name: "Healthcare",
    description: "Digitise healthcare operations with secure, intelligent solutions that improve patient care, streamline clinical workflows and simplify hospital management.",
    icon: HeartPulse,
    gradient: "from-rose-200/60 to-primary/10",
    tags:["Hospitals", "Laboratories", "Clinics",  "Telemedicine"],
  },
  {
    id: "retail",
    name: "Retail & E-commerce",
    description: "Deliver seamless omnichannel retail experiences with intelligent digital solutions that connect customers, stores, inventory and operations.",
    icon: ShoppingBag,
    gradient: "from-amber-200/60 to-accent/10",
    tags: ["Inventory", "E-Commerce", "CRM", "Analytics"],
  },
  {
    id: "restaurants",
    name: "Restaurants",
    description: "Digitise restaurant operations with intelligent solutions that streamline front-of-house, kitchen, inventory and customer engagement.",
    icon: UtensilsCrossed,
    gradient: "from-emerald-200/60 to-primary/10",
    tags: ["Bookings", "POS", "Inventory", "Housekeeping"],
  },
  // {
  //   id: "saas",
  //   name: "SaaS",
  //   description: "From activation to expansion — products that compound.",
  //   icon: Cloud,
  //   gradient: "from-accent/20 to-primary/10",
  // },
  {
    id: "education",
    name: "Education",
    description: "Digitise educational institutions with secure, intelligent solutions that simplify administration, improve learning experiences and strengthen communication between educators, students and parents.",
    icon: GraduationCap,
    gradient: "from-indigo-200/60 to-accent/10",
    tags:["Schools", "Colleges", "LMS", "Admissions"],
  },
  {
    id: "logistics",
    name: "Logistics",
    description: "Optimise logistics and supply chain operations with intelligent digital solutions that improve visibility, automate workflows and streamline transportation, warehousing and delivery.",
    icon: Truck,
    gradient: "from-emerald-200/60 to-primary/10",
    tags: ["Fleet", "GPS", "Delivery", "Tracking"],
  },
  {
    id: "government",
    name: "Government",
    description: "Modernise public services with secure digital solutions that improve citizen experience, automate government workflows and increase operational transparency.",
    icon: GraduationCap,
    gradient: "from-emerald-200/60 to-primary/10",
    tags: ["Citizen Services", "Approvals", "Documents", "Audit"],
  },
];
